const skillWeights = {
  ACT_English: {
    "Ambiguity & Series": 0.0110117,
    Apostrophes: 0.0254646,
    "Colons & Semicolons": 0.00619408,
    "Parenthetical Elements": 0.0467997,
    "Unnecessary Commas": 0.0509291,
    "Faulty Coordination & Subordination": 0.0470229,
    "Fragments & Fused Sentences": 0.0360019,
    "Misplaced Modifiers": 0.0345325,
    Parallelism: 0.011021,
    "Participial Phrases": 0.0161641,
    "Relative Pronouns": 0.0183683,
    "Verb Tense & Pronoun Person": 0.0419821,
    "Adjectives & Adverbs": 0.0144529,
    "Comparatives & Superlatives": 0.00894701,
    "Confusing Pairs": 0.00550585,
    "Forming Verbs": 0.0103235,
    Idiom: 0.00206469,
    Prepositions: 0.026841,
    "Pronoun-Antecedent Agreement": 0.0399174,
    Pronouns: 0.0185822,
    "Subject-Verb Agreement": 0.0247763,
    Conjunctions: 0.0,
    Redundancy: 0.0825877,
    "Style & Tone": 0.011,
    "Vague & Clumsy Writing": 0.0213352,
    "Word Choice": 0.053682,
    "Introductions & Conclusions": 0.0323469,
    "Paragraph Division": 0.00757054,
    "Paragraph Sequence": 0.00481762,
    "Sentence Placement": 0.0159,
    "Sentence Sequence": 0.0159,
    Transitions: 0.0956641,
    "Accomplish Purpose": 0.044735,
    "Author's Purpose": 0.0729525,
    Relevance: 0.0213352,
    "Writer's Goal": 0.0227116
  },
  ACT_Math: {
    Operations: 0.0552,
    Percent: 0.0276,
    Proportions: 0.0138,
    Ratios: 0.0069,
    Arithmetic: 0.1035,
    "Creating Expressions": 0.0185567,
    "Exponents & Roots": 0.0376289,
    Expressions: 0.0134021,
    "Inequalities & Absolute Value": 0.0404,
    "Properties of Algebra": 0.0,
    Slope: 0.0,
    "Solving Equations": 0.122165,
    "Equations: Coordinate Plane": 0.0,
    "Equations: Modeling & Relations": 0.0,
    "Creating Functions": 0.0185567,
    "Domain, Range, & Function": 0.0,
    "Function Graphs - Coordinate Plane": 0.0175258,
    "Function Graphs - Modeling & Relations": 0.0155,
    "Functions - Understanding & Evaluating": 0.035567,
    Logarithms: 0.00773196,
    Modeling: 0.0,
    "Patterns & Sequences": 0.0195876,
    "Properties of Functions": 0.0,
    "Trig Functions": 0.0123711,
    "Angles & Shapes": 0.0623711,
    "Area, Perimeter, Volume & Circumference": 0.11134,
    "Circles & Parabolas - Coordinate Plane": 0.0247423,
    "Circles - Plane Geometry": 0.0293814,
    "Slope, Midpoint & Distance": 0.0654639,
    Logic: 0.0001,
    "Locating Points": 0.0,
    "Translation, Rotation, Reflection & Relative Equations": 0.0221649,
    Triangles: 0.042268,
    "Trig Geometry": 0.0345361,
    "Using Formulas": 0.0,
    "Complex Numbers": 0.0,
    Computation: 0.0,
    "Exponents & Place Value": 0.0128866,
    Factors: 0.0159794,
    Fractions: 0.0206186,
    Matrices: 0.0,
    "Number Concepts & Properties": 0.0221649,
    "Number Line & Absolute Value": 0.0,
    "Averages, Median & Mode": 0.0237113,
    Counting: 0.0159794,
    "Data Interpretation": 0.0180412,
    Probability: 0.0159794,
    "Studies & Models": 0.0
  },
  ACT_Reading: {
    "Analyze Word & Phrase Choices": 0.0620155,
    "Interpret Words & Phrases": 0.0930233,
    "Intent & Purpose": 0.0826873,
    "Point of View": 0.0310078,
    "Analyze Structure": 0.00516796,
    Function: 0.0155039,
    "Relate to Passage as a Whole": 0.0310078,
    "Identifying Claims": 0.0439276,
    "Supporting Claims": 0.0645995,
    "Compare Two Texts": 0.0129199,
    "Conclusions Two Texts": 0.0,
    "Central Ideas & Themes": 0.0361757,
    "Summarize Key Ideas & Details": 0.136951,
    "Draw Conclusions": 0.111111,
    Locate: 0.191214,
    Paraphrase: 0.0310078,
    "Cause-Effect Relationships": 0.00775194,
    "Comparative Relationships": 0.0284238,
    "Sequence of Events": 0.0001,
    "Central Ideas": 0.0361757
  },
  ACT_Science: {
    "Assumptions, Strengths & Weaknesses": 0.0102828,
    "Compare Models": 0.0179949,
    "Consistency of Hypotheses, Predictions & Conclusions": 0.0359897,
    "Model Information": 0.0257069,
    "New Information & Predictions in Models": 0.0257069,
    "Support of Hypotheses": 0.0745501,
    "Support or Weakening of Models": 0.0154242,
    "Compare or Combine": 0.0976864,
    "Creating Figures": 0.0514139,
    "Interpolation & Extrapolation": 0.0411311,
    "New Information": 0.0282776,
    "Select Data & Features": 0.267352,
    Terminology: 0.0308483,
    "Text & Representations": 0.0411311,
    "Variables & Mathematical Relationships": 0.0514139,
    Comparison: 0.00257069,
    Control: 0.0179949,
    Hypothesis: 0.00771208,
    Methods: 0.00771208,
    "Precision & Accuracy": 0.00771208,
    "Prediction & Further Experiments": 0.0951157,
    "Text & Experiments": 0.0179949,
    Tools: 0.00514139,
    "Understanding Design": 0.0231362
  },

  //TODO: Need new weights for sat subjects, using defaults for now.
  SAT_Reading: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.0361757
  },
  SAT_Math: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  "SAT_Math - Calc": {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  "SAT_Math - No Calc": {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  "SAT_Writing and Language": {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  PSAT_Reading: {
    Rhetoric: 0.0620155,
    Purpose: 0.0930233,
    "Word choice": 0.0826873,
    Arguments: 0.0155039,
    "Assessing reasoning": 0.0361757,
    "Analyzing evidence": 0.0310078,
    "Claims and counterclaims": 0.0284238,
    "Analyzing purpose": 0.0129199,
    "Point of view": 0.0826873,
    "Text structure": 0.0155039,
    "Part-whole relationships": 0.0284238,
    "Overall structure": 0.0361757,
    Synthesis: 0.0310078,
    "Multiple texts": 0.0826873,
    "Quantitative information (S)": 0.0284238,
    "Information and Ideas": 0.0129199,
    Summarizing: 0.0155039,
    "Understanding relationships": 0.0826873,
    "Interpreting words and phrases": 0.0284238,
    "Central ideas and themes": 0.0310078,
    "Reading closely": 0.0361757,
    "Explicit meanings": 0.0129199,
    "Implicit meanings": 0.0826873,
    "Analogical reasoning": 0.0155039,
    "Citing textual evidence": 0.0361757
  },
  PSAT_Math: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  "PSAT_Math - Calc": {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  "PSAT_Math - No Calc": {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  "PSAT_Writing and Language": {
    "Expression of Ideas": 0.0110117,
    "Effective language use": 0.0254646,
    Syntax: 0.00619408,
    "Style and tone": 0.0467997,
    Concision: 0.0509291,
    Precision: 0.0470229,
    Organization: 0.053682,
    "Logical sequence": 0.00550585,
    "Introductions, conclusions, and transitions": 0.0956641,
    Development: 0.0470229,
    Support: 0.0399174,
    Focus: 0.0399174,
    "Quantitative information (D)": 0.0399174,
    Proposition: 0.0399174,
    "Standard English Conventions": 0.0399174,
    "Sentence structure": 0.0470229,
    "Sentence formation": 0.053682,
    "Sentence boundaries": 0.00550585,
    "Parallel structure": 0.0956641,
    "Subordination and coordination": 0.0956641,
    "Modifier placement": 0.0470229,
    "Inappropriate shifts in construction": 0.0956641,
    "Pronoun person and number": 0.00894701,
    "Verb tense, mood, and voice": 0.0956641,
    "Conventions of usage": 0.00550585,
    Agreement: 0.0470229,
    "Noun agreement": 0.00894701,
    "Subject-verb agreement": 0.0399174,
    "Pronoun-antecedent agreement": 0.00550585,
    "Logical comparison": 0.0470229,
    "Conventional expression": 0.0956641,
    "Frequently used words": 0.0956641,
    Pronouns: 0.0470229,
    "Pronoun clarity": 0.00894701,
    "Possessive determiners": 0.053682,
    "Conventions of punctuation": 0.0399174,
    "Unnecessary punctuation": 0.0470229,
    "End-of-sentence punctuation": 0.0956641,
    "Possessive nouns and pronouns": 0.00550585,
    "Within-sentence punctuation": 0.053682,
    "Nonrestrictive and parenthetical elements": 0.0956641,
    "Items in a series": 0.0399174
  },
  "STAAR_English I": {
    Editing: 1,
    Capitalization: 1,
    Pronouns: 1,
    Punctuation: 1,
    "Sentence formation": 1,
    Spelling: 1,
    "Verb tense": 1,
    "Informational Texts": 1,
    "Diction and tone": 1,
    "Print and graphic features": 1,
    Purpose: 1,
    Inferences: 1,
    "Paraphrasing and summarizing": 1,
    Structure: 1,
    "Supporting a response": 1,
    "Literary Texts": 1,
    "Literary devices": 1,
    "Word choice": 1,
    "Dramatic conventions": 1,
    Characterization: 1,
    "Plot and point of view": 1,
    Theme: 1,
    "Reading Across Genres": 1,
    "Making connections": 1,
    "Synthesizing information": 1,
    "Connotation and denotation": 1,
    "Dictionary skills": 1,
    "Foreign words": 1,
    Revision: 1,
    "Developing ideas": 1,
    Organization: 1,
    "Revising drafts": 1
  },
  "STAAR_Algebra I": {
    "Describing and Graphing Linear Functions, Equations, and Inequalities": 1,
    "Graphing linear functions": 1,
    "Graphing linear inequalities": 1,
    "Graphing linear systems": 1,
    "Graphing systems of inequalities": 1,
    "Rate of change": 1,
    Slope: 1,
    "Solutions to a linear system": 1,
    Transformations: 1,
    "Association and causation": 1,
    "Correlation coefficient": 1,
    "Line of best fit": 1,
    "Exponential Functions and Equations": 1,
    "Domain and range": 1,
    "Growth and decay": 1,
    "Interpreting exponential functions": 1,
    "Reasonable fit to data": 1,
    "Writing exponential functions": 1,
    "Number and Algebraic Methods": 1,
    "Function definition": 1,
    "Function notation": 1,
    "Identifying terms in a sequence": 1,
    "Literal equations": 1,
    "Sequence formulas": 1,
    "Laws of exponents": 1,
    "Radical expressions": 1,
    "Adding and subtracting": 1,
    "Difference of two squares": 1,
    "Distributive property": 1,
    Dividing: 1,
    Factoring: 1,
    Multiplying: 1,
    "Quadratic Functions and Equations": 1,
    "Graphing quadratic functions": 1,
    "Linear factors and zeros": 1,
    "Real solutions": 1,
    "Vertex form": 1,
    "Writing and Solving Linear Functions, Equations, and Inequalities": 1,
    "Linear equations, one variable": 1,
    "Linear inequalities, one variable": 1,
    "Systems of equations": 1,
    "Direct variation": 1,
    "Linear equations, two variables": 1,
    "Linear inequalities, two variables": 1,
    "Linear systems": 1,
    "Parallel lines": 1,
    "Perpendicular lines": 1,
    "Point and slope": 1,
    "Zero and undefined slope": 1
  },
  STAAR_Biology: {
    "Biological Processes and Systems": 1,
    "Interactions of systems in animals": 1,
    "Interactions of systems in plants": 1,
    "Levels of organization": 1,
    Biomolecules: 1,
    Enzymes: 1,
    "Photosynthesis and cellular respiration": 1,
    "Cell Structure and Function\t": 1,
    "Disruption of the cell cycle": 1,
    "Role of DNA and RNA": 1,
    "Stages of the cell cycle": 1,
    "Cellular processes": 1,
    "Prokaryotes and eukaryotes": 1,
    "Viral structure, reproduction, and function": 1,
    "Evolution and Classification\t": 1,
    "Abrupt appearance and stasis": 1,
    "Adaptation and diversity": 1,
    "Changes in populations": 1,
    "Effects of natural selection": 1,
    "Evidence of common ancestry": 1,
    "Evolutionary mechanisms": 1,
    "Comparison of taxonomic groups": 1,
    "Definition and importance": 1,
    "Hierarchical classification": 1,
    "Interdependence Within Environmental Systems": 1,
    "Ecological succession": 1,
    "Role of microorganisms": 1,
    "Environmental change and ecosystem stability": 1,
    "Relationships among organisms": 1,
    "The carbon and nitrogen cycles": 1,
    "Trophic levels": 1,
    "Variations and adaptations": 1,
    "Mechanisms of Genetics": 1,
    DNA: 1,
    "DNA mutations": 1,
    "Gene expression": 1,
    "Genetic code commonalities": 1,
    "Genetic crosses": 1,
    Meiosis: 1,
    "Transcription and translation": 1
  },
  "STAAR_English II": {
    Editing: 1,
    Capitalization: 1,
    Pronouns: 1,
    Punctuation: 1,
    "Sentence formation": 1,
    Spelling: 1,
    "Verb tense": 1,
    "Informational Texts": 1,
    "Diction and tone": 1,
    "Print and graphic features": 1,
    Purpose: 1,
    Inferences: 1,
    "Paraphrasing and summarizing": 1,
    Structure: 1,
    "Supporting a response": 1,
    "Literary Texts": 1,
    "Literary devices": 1,
    "Word choice": 1,
    Characterization: 1,
    "Plot and point of view": 1,
    Theme: 1,
    "Poetic conventions": 1,
    "Reading Across Genres": 1,
    "Making connections": 1,
    "Synthesizing information": 1,
    "Connotation and denotation": 1,
    "Dictionary skills": 1,
    "Foreign words": 1,
    Revision: 1,
    "Developing ideas": 1,
    Organization: 1,
    "Revising drafts": 1
  },
  "STAAR_U.S. History": {
    "Economics, Science, Technology, and Society": 1,
    "Scientific discoveries and technological innovations": 1,
    "Technological innovations in the workplace": 1,
    "The impact of need on scientific discovery": 1,
    "Free enterprise's effect on the standard of living": 1,
    "Innovation and the marketplace": 1,
    "Foreign policies and the economy": 1,
    "International military conflicts": 1,
    "The federal government and private business": 1,
    "Transcontinental Railroad and the Homestead Act": 1,
    "1920s growth and prosperity": 1,
    "Causes of the Great Depression": 1,
    "Effects of the Great Depression": 1,
    "New Deal agencies and programs": 1,
    "New Deal policies and opponents": 1,
    "Causes of prosperity in the 1950s": 1,
    "Economic impact of defense spending": 1,
    "Effects of World War II on the homefront": 1,
    "Government policies to create economic opportunities": 1,
    "U.S. international trade policies": 1,
    "Geography and Culture": 1,
    "Global diffusion of American culture": 1,
    "Impact of cultural movements": 1,
    "Reflection of historical issues through various genres of art": 1,
    "Americanization movement": 1,
    "Contributions of various groups to American culture": 1,
    "Contributions of women to society": 1,
    "Expansion of economic opportunities and political rights": 1,
    "Impact of geography on major events": 1,
    "Causes and effects of immigration": 1,
    "Demographic patterns of migration": 1,
    "Effects of population growth": 1,
    "Government and citizen roles in managing the environment": 1,
    "Government and Citizenship": 1,
    "American exceptionalism": 1,
    "Constitutional issues and government policies ": 1,
    "Effects of political scandals": 1,
    "Impact of New Deal legislation": 1,
    "Role of contemporary government legislation": 1,
    "Effects of landmark U.S. Supreme Court decisions": 1,
    "Landmark constitutional amendments": 1,
    "Congressional Medal of Honor recipients": 1,
    "Significant political and social leaders": 1,
    "Equality of political rights": 1,
    "Methods of participating in the democratic process": 1,
    "National identity, patriotism, and civic responsibility": 1,
    "Process for becoming a naturalized citizen": 1,
    "Gulf of Tonkin Resolution and the War Powers Act": 1,
    "The legislative, executive, and judicial branches": 1,
    History: 1,
    "Black Panthers versus Martin Luther King Jr.": 1,
    "Civil rights changes in the U.S.": 1,
    "Historical development from the late 1800s": 1,
    "Landmark U.S. Supreme Court decisions": 1,
    "Obstacles to civil rights and voting": 1,
    "Presidential and congressional actions ": 1,
    "Reaction of Southern Democrats": 1,
    "Roles of civil rights leaders": 1,
    "Roles of civil rights organizations": 1,
    "Writings of Martin Luther King Jr.": 1,
    "Founding principles of the U.S.": 1,
    "National mottos": 1,
    "Understanding the Founding Documents": 1,
    "Causes and effects of social issues": 1,
    "Impact of individuals": 1,
    "Impact of third parties": 1,
    "Muckrakers and reform leaders": 1,
    "Progressive era reforms": 1,
    "Domestic responses to the Vietnam War": 1,
    "Domestic tensions": 1,
    "Reasons for U.S. foreign involvement": 1,
    "The Korean War": 1,
    "The Vietnam War": 1,
    "U.S. responses to Soviet aggression": 1,
    "American Indian policies, political machines, and civil service reform": 1,
    "Domestic economic issues": 1,
    "Domestic social issues": 1,
    "Major eras": 1,
    "Major turning points": 1,
    "American expansionism": 1,
    "Issues raised by U.S. involvement in World War I": 1,
    "Technological innovations of World War I": 1,
    "U.S. as a world power": 1,
    "U.S. contributions during World War I": 1,
    "World War I": 1,
    "Conservative resurgence": 1,
    "Richard M. Nixon": 1,
    "Ronald Reagan": 1,
    "Societal issues": 1,
    "U.S. involvement in the Middle East": 1,
    "Significant social and political issues": 1,
    "The economy of the 21st century": 1,
    "U.S. involvement in world affairs": 1,
    "Contributions of military leaders": 1,
    "Examples of inspired American patriotism ": 1,
    "Issues on the home front": 1,
    "Major issues of World War II": 1,
    "Major military events of World War II": 1,
    "Reasons for U.S. involvement": 1,
    "U.S. presidential leadership": 1
  }
}

export default skillWeights
